/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { jsx, css } from '@emotion/react'
import { head, get } from 'lodash'
import { confirmModal } from '../../actions/ui'
import {showSuccess, showError} from '../../actions/Error'
import AdminMainLayout from './AdminMainLayout'
import AdminUserForm from './AdminUserForm'
import BusyMask from '../../components/BusyMask'
import { globalSettingsList } from '../../actions/settings'
import { adminEditableEmailList } from '../actions/admin_editable_email'
import { adminEditableEmailCustomParameterList } from '../actions/admin_editable_email_custom_parameter'
import { adminServerSyncImport } from '../actions/admin_server_sync'
import Card from '../../components/layout/Card'
import { Button, Container } from 'react-bootstrap'
import { WhiteButton } from '../../components/layout/WhiteButton'
import AdminTableHeader from './AdminTableHeader'
import AdminTableFilter from './AdminTableFilter'
import EditableEmailsTable from './EditableEmailsTable'

class AdminEditableEmails extends Component {

    componentDidMount() {
        const { dispatch, customer_id } = this.props
        // Manual (admin authored) emails have their own page - keep them out of the catalogue list.
        dispatch(adminEditableEmailList.updateListFilter({is_manual: false}))
        dispatch(adminEditableEmailList.fetchListIfNeeded())
        dispatch(globalSettingsList.ensureGlobalSettingsLoaded())
    }

    componentDidUpdate(prev_props) {
        const { dispatch } = this.props
        dispatch(adminEditableEmailList.fetchListIfNeeded())
    }

    onSync = () => {
        const { dispatch, server_sync_server_url } = this.props

        const on_ok = function(json) {
            if ( json.status !== 'success' ) {
                showError("Sync failed", "Sync could not be completed")
                return
            } 
            showSuccess("Synced", "The email list has been synced")
            dispatch(adminEditableEmailList.invalidateList())
            dispatch(adminEditableEmailList.fetchListIfNeeded())
            dispatch(adminEditableEmailList.invalidateList())
            dispatch(adminEditableEmailCustomParameterList.invalidateList())
        }
        
        const onConfirmed = () => {
            return dispatch(adminServerSyncImport.saveNewObject({})).then(on_ok)
        }
        
        return dispatch(confirmModal({text:`Import emails and parameters from ${server_sync_server_url}?`,
                                      onConfirmed: onConfirmed}))
    }

    onManualEmails = () => {
        const { history } = this.props
        history.push('/admin/manual_editable_emails/')
    }

    filterEditableEmails = (filter_values) => {
        const { dispatch } = this.props
        dispatch(adminEditableEmailList.updateListFilter(filter_values))
    }

    render() {
        const { is_loading, can_sync, server_sync_server_url, editable_emails } = this.props
        return (
            <AdminMainLayout breadcrumbs={[{name: 'admin_home'},
                                           {name: 'editable_emails', label: 'Editable Emails', url: '/admin/editable_emails'}]}>
              <Container fluid>
                <AdminTableHeader title="Editable Emails">
                  <div css={ css`width:100%;`}>
                    <AdminTableFilter
                        updateOnChange={ this.filterEditableEmails }
                        form="ADMIN_EDITABLE_EMAILS_FILTER_FORM"
                    />
                  </div>

                  { can_sync &&
                    <WhiteButton onClick={this.onSync}>
                      Import Emails
                    </WhiteButton>
                  }

                  <WhiteButton onClick={this.onManualEmails}>
                    Manual Emails
                  </WhiteButton>

                </AdminTableHeader>
                <EditableEmailsTable
                    is_loading={ is_loading }
                    empty_message={`There are no editable emails.`}
                    items={ editable_emails }
                    item_list={adminEditableEmailList}
                />
              </Container>
            </AdminMainLayout>
        )
    }
    
}

function mapStateToProps(state, props) {
    const editable_emails = adminEditableEmailList.getVisibleObjects()
    const server_sync_server_url = globalSettingsList.getSetting('server_sync_server_url')
    return {
        editable_emails,
        is_loading: adminEditableEmailList.isLoading() || adminServerSyncImport.getIsSavingObject(),
        server_sync_server_url,
        can_sync: Boolean(server_sync_server_url) && !globalSettingsList.getSetting('can_edit_editable_emails'),
    }
}

export default connect(mapStateToProps)(AdminEditableEmails)
